import { createFileRoute } from "@tanstack/react-router";

import { UtilisateursPage } from "@/features/utilisateurs/UtilisateursPage";

export const Route = createFileRoute("/_connecte/utilisateurs/")({
  component: UtilisateursPage,
});
